import React, { PropsWithChildren } from 'react';
import { Form } from '@wearejh/rx-form/lib/compat/informed';

import { Spinner } from 'src/components/Layout/Spinner';
import { Button } from 'src/components/Button/Button';
import { ErrorFor } from 'src/components/Forms/ErrorFor';
import { Svg } from 'src/components/Svg/Svg';
import { InlineSubmit } from 'src/components/StoreLocator/InlineSubmit';

import classes from './LocationLookup.scss';

type Props = {
    pending?: boolean;
    submitAddress: (address: string) => void;
    submitGeo: () => void;
};

export function LocationLookup(props: PropsWithChildren<Props>) {
    return (
        <div className={classes.root}>
            {props.pending && (
                <div className={classes.spinner}>
                    <Spinner />
                </div>
            )}
            <div className={classes.address}>
                <Form onSubmit={(values) => props.submitAddress(values.address)} data-test-id="BranchFinder_form">
                    <fieldset disabled={props.pending}>
                        <InlineSubmit field="address" submitText="Search" />
                    </fieldset>
                    <ErrorFor field="address" />{' '}
                </Form>
            </div>
            <div className={classes.geo}>
                <Button
                    variant="secondary"
                    width="full"
                    type="button"
                    title="Use Current Location"
                    onClick={props.submitGeo}
                >
                    <span className={classes.geoIcon}>
                        {/* todo: target icon */} <Svg name="place" />
                    </span>
                    Use Current Location{' '}
                </Button>
            </div>
        </div>
    );
}
